/** a code chunk that failed to load is asked for once more after this */
export const IMPORT_RETRY_MS = 1500

/**
 * A dynamic import that survives one failed load (a flaky mobile link):
 * webpack forgets a chunk that failed, so a second import() fetches it again.
 * A second failure is the caller's.
 */
export const importWithRetry = <T>(load: () => Promise<T>): Promise<T> =>
  load().catch(
    () =>
      new Promise<T>((resolve, reject) => {
        setTimeout(() => load().then(resolve, reject), IMPORT_RETRY_MS)
      })
  )
